import { Component, Input, OnInit } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseFormFieldComponent } from "../base-form-field.component";

import { OrderStatus } from "src/services/order/order-status.type";
import { OrderStatusValues } from "src/services/order/order-display";

@Component({
  selector: "rc-order-status-form-field",
  templateUrl: "./order-status-form-field.component.html",
  styleUrls: ["./order-status-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: OrderStatusFormFieldComponent,
    },
  ],
  standalone: false,
})
export class OrderStatusFormFieldComponent extends BaseFormFieldComponent<OrderStatus> implements OnInit {
  @Input() public withLabel: boolean = false;

  constructor() {
    super();
  }

  public async ngOnInit(): Promise<void> {
    this.fieldValue = this.initialValue;
    super.ngOnInit();
  }

  public async onInputChange(event: unknown): Promise<void> {
    const ionEvent = event as CustomEvent;

    const inputValue = ionEvent.detail.value;

    await this.onInputChangeInternal(inputValue);
  }

  protected async toDisplayValue(input: OrderStatus): Promise<string> {
    if (!input) {
      return "";
    }

    return input;
  }

  public orderStatusValues = OrderStatusValues;
}
